import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UserService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.userSubject = new BehaviorSubject({});
        this.userObservable = this.userSubject.asObservable();
        this.isAdminUser = new BehaviorSubject(undefined);
        this.isAdminUserObs = this.isAdminUser.asObservable();
    }
    setUserData(dataUser) {
        this.userSubject.next(dataUser);
    }
    setIsAdminUser(value) {
        console.log("setIsAdminUser", value);
        this.isAdminUser.next(value);
    }
    getUserData() {
        return this.userObservable;
    }
    getUserAuthorization() {
        return this.httpClient.get(environment.api.base + 'users/authorization');
    }
    getUserList() {
        return this.httpClient.get(environment.api.base + 'users');
    }
    getUserByMail(email) {
        return this.httpClient.get(environment.api.base + `users/user/${email}`);
    }
    getIsAdminUser() {
        return this.isAdminUserObs;
    }
    checkEmail(email) {
        return this.httpClient.get(`${environment.api.base}users/user/${email}/check`, { responseType: 'text' });
    }
    addUser(user) {
        console.log(user);
        return this.httpClient.post(`${environment.api.base}users`, user);
    }
    updateUser(user) {
        return this.httpClient.put(`${environment.api.base}users`, user);
    }
    deleteUser(user) {
        return this.httpClient.request('DELETE', `${environment.api.base}users`, {
            body: user,
        });
    }
    getUserConvergencia(request) {
        return this.httpClient.get(environment.api.base + `convergences/users?request=${request}`).pipe(catchError((err) => {
            if (err.error instanceof Error) {
                console.error('Error:', err.error.message);
            }
            else {
                console.error(`Backend error code ${err.status} : ${err.error}`);
            }
            return new Observable();
        }));
    }
    addUserAnalysis(_Data) {
        return this.httpClient.put(environment.api.base + `icrs/UpdateAnalysisConfigMail`, _Data);
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient)); }, token: UserService, providedIn: "root" });
